<template>
    <div class="ipo-box">
        <div class="ipo-title">
            <span>IPO专题</span>
        </div>

        <!-- <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(item, index) of nav"
            :key="index"
            @click="handleSelect(index)">{{item.label}}</el-menu-item>
        </el-menu>

        <ul class="ipo-list">
            <li
            v-for="(item, index) in list"
            :key="index">
                <el-link
                :href="item.body"
                target="_blank"
                :underline="false">
                    <img
                    :src="item.image"
                    lazy>
                </el-link>
            </li>
        </ul> -->
    </div>
</template>

<script>
// import { getProject } from '../../api'

export default {
    name: 'Ipolisted',
    // data() {
    //     return {
    //         activeIndex: '1',
    //         name: '零售电商',
    //         nav: [
    //             {
    //                 value: '零售电商',
    //                 label: '零售电商'
    //             },
    //             {
    //                 value: '服务电商',
    //                 label: '服务电商'
    //             },
    //             {
    //                 value: '跨境电商',
    //                 label: '跨境电商'
    //             },
    //             {
    //                 value: '产业电商',
    //                 label: '产业电商'
    //             },
    //             {
    //                 value: '在线教育',
    //                 label: '在线教育'
    //             },
    //             {
    //                 value: '',
    //                 label: ''
    //             },
    //             {
    //                 value: '',
    //                 label: ''
    //             },
    //             {
    //                 value: '',
    //                 label: ''
    //             },
    //         ],
    //         params: {
    //             p: 1,
    //             cate: '上市公司'
    //         },
    //         list: []
    //     }
    // },
    // mounted() {
    //     getProject(this.params)
    //     .then(res => {
    //         console.log(res)
    //         this.list = res.list
    //     })
    // },
    // methods: {
    //     handleSelect(index) {
    //         this.list.forEach(item => {
    //             if(!document.title.includes(item.title)) {
    //                 list.push(item)
    //             }
    //         })
    //     }
    // }
}
</script>

<style>

</style>